module.exports = __webpack_public_path__ + "img/appAsset-banks--boleto.4fef276c.svg";